import { createAsyncThunk } from '@reduxjs/toolkit';

import { StatusEnum } from '@common/constants';
import { fetch } from '@common/fetch';
import { downLoadFromBlob } from '@common/utils';

import { ParamsWithDependentUserId } from '../../../types';
import { allergiesStatusSelector } from './selectors';
import { AllergiesItem } from './types';

export const getAllergies = createAsyncThunk<AllergiesItem[], ParamsWithDependentUserId>(
  'HealthSummary/get-allergies',
  async ({ dependentUserId }, { rejectWithValue }) => {
    try {
      const data = fetch.get({
        url: '/HealthSummary/allergies',
        params: {
          dependentUserId,
        },
      });

      const res = await data.response;

      return res?.data.allergies;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
  {
    condition: (_, { getState }) => allergiesStatusSelector(getState() as RootState) !== StatusEnum.Pending,
  },
);

export const downloadAllergiesReport = createAsyncThunk<unknown, ParamsWithDependentUserId>(
  'HealthSummary/allergies-report',
  async ({ dependentUserId }: ParamsWithDependentUserId, { rejectWithValue }) => {
    try {
      const data = fetch.get({
        url: '/HealthSummary/reports/allergies',
        responseType: 'blob',
        params: { dependentUserId },
      });

      const res = await data.response;
      const blob = res?.data;
      downLoadFromBlob(blob, 'application/pdf', 'allergies-report');
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
